export default __webpack_public_path__ + "static/media/MYSTERYBET.4355f1e2.svg";